module.exports = __webpack_public_path__ + "img/li.7927a58.svg";